<span *ngIf="show" [ngStyle]="styles" class="status-loading">{{ text }}<span>.</span><span>.</span><span>.</span></span>
